import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import React, {
  Component,
} from 'react';
import ReactDOM from 'react-dom';
import Directives from '../../../Directives/Directives';
import classes from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IMultipleSelectField,
} from '../formFields';

interface IProps extends IMultipleSelectField {
  errors: any;
  touched: any;

  onChange(name: string): any;
}

class MultipleSelectField extends Component<IProps> {
  state = {
    labelWidth: 0,
  };

  InputLabelRef: any = {
  };

  getValue = (selectedKey: any) => {
    const selectedIndex = this.props.selectList.findIndex((ele) => ele[this.props.selectListKey] === selectedKey);
    if (selectedIndex !== -1) {
      return this.props.selectList[selectedIndex][this.props.selectListValue];
    }
    return '';
  };

  render() {
    return (
      <FormControl variant="outlined" className={classes.filed}>
        <InputLabel
          ref={(ref) => {
            this.InputLabelRef = ref;
          }}
          htmlFor="select-multiple-chip"
        >
          {this.props.label}
        </InputLabel>
        <Select
          multiple
          name={this.props.name}
          value={this.props.value}
          onChange={this.props.onChange(this.props.name)}
          input={(
            <OutlinedInput
              labelWidth={this.state.labelWidth}
              id="select-multiple-chip"
            />
)}
          renderValue={(selected: any) => (
            <div className={classes.chips}>
              {
                selected.map((selectedKey: any) => (
                  <Chip key={selectedKey} label={this.getValue(selectedKey)} className={classes.chip} />
                ))
              }
            </div>
          )}
        >
          {this.props.selectList.map((name: any, index: number) => (
            <MenuItem key={name[this.props.selectListKey]} value={name[this.props.selectListKey]}>
              {name[this.props.selectListValue]}
            </MenuItem>
          ))}
        </Select>
        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={classes.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }

  componentDidMount() {
    const ele: any = ReactDOM.findDOMNode(this.InputLabelRef);
    this.setState({
      labelWidth: ele.offsetWidth,
    });
  }
}

export default MultipleSelectField;
